var map = {
	"./dept-1.svg": "2e23",
	"./dept-10.svg": "db97",
	"./dept-11.svg": "a19f",
	"./dept-12.svg": "9f0a",
	"./dept-2.svg": "7ed1",
	"./dept-3.svg": "e889",
	"./dept-4.svg": "547f",
	"./dept-5.svg": "683d",
	"./dept-6.svg": "9a24",
	"./dept-7.svg": "c49e",
	"./dept-8.svg": "550b",
	"./dept-9.svg": "640e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dfc7";